import {Component, Input, Output, EventEmitter} from 'angular2/core';
import {PaginationControlsCmp} from "ng2-pagination";

/*
    This component is a generic component used to display pagination. It is a wrapper of the PaginationControls component,
    provide by the ng2-pagination library.
 */

@Component({
    selector: 'bootstrap-pagination',
    templateUrl: './app/components/common/pagination/pagination.html',
    directives: [PaginationControlsCmp],
})
export class BootstrapPaginationComponent {
    @Input()
    id;

    @Output()
    getPage:EventEmitter<number> = new EventEmitter<number>();

    pageChange($event) {
        this.getPage.emit($event);
    }

}